import { useParams } from "react-router-dom";

import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import Heading from './components/Heading';
import OfferTabsRouter from './components/TabsRouter';
import OfferFormLyout from './containers/Form';
import { OfferActiveProvider } from './context';
import { useOfferStore, OfferProvider } from './store';

function OfferFormLyoutAttribute(props) {
  return <OfferFormLyout {...props} isAttribute={true} />;
}

function OfferFormLyoutNotAttribute(props) {
  return <OfferFormLyout {...props} isAttribute={false} />;
}

function OfferForm() {
  const { id } = useParams()
  const { collection: { useLoad, item } } = useOfferStore()

  useLoad(id)

  return <OfferActiveProvider item={item}>
    <Heading data={item} />
    <OfferTabsRouter id={id} />
    <Router>
      <PrivateRoute exact path="/offer/offers/:id" component={OfferFormLyoutNotAttribute} />
      <PrivateRoute path="/offer/offers/:id/attributes" component={OfferFormLyoutAttribute} />
    </Router>
  </OfferActiveProvider>
}

export default function OfferFormLayout() {
  return <OfferProvider>
    <OfferForm />
  </OfferProvider>
}

